import {
  Button,
  ButtonGroup,
  H2,
  Modal,
} from "@datapay-by-datacom/design-system";
import { useState } from "react";
import { Org } from "../../../generated/core-api";
import s from "./BindOrgModal.module.css";

interface BindOrgModalProps {
  isOpen: boolean;
  onClose: () => void;
  onBind: (orgId: string, orgCategory: string) => void;
  isPending: boolean;
  availableOrgs: Org[];
}

export function BindOrgModal({
  isOpen,
  onClose,
  onBind,
  isPending,
  availableOrgs,
}: BindOrgModalProps) {
  const [selectedOrgId, setSelectedOrgId] = useState("");

  const selectedOrg = availableOrgs.find((org) => org.id === selectedOrgId);

  const handleBind = () => {
    if (!selectedOrg) return;
    onBind(selectedOrg.id, selectedOrg.category);
    setSelectedOrgId("");
  };

  const handleClose = () => {
    setSelectedOrgId("");
    onClose();
  };

  return (
    <Modal isOpen={isOpen}>
      <div className={s.modal}>
        <H2>Bind Organization</H2>
        <p className={s.description}>
          Select an organization to bind to this group.
        </p>

        <div className={s.field}>
          <label className={s.label} htmlFor="bind-org-select">
            Organization
          </label>
          <select
            id="bind-org-select"
            className={s.select}
            value={selectedOrgId}
            onChange={(e) => setSelectedOrgId(e.target.value)}
            disabled={isPending}
          >
            <option value="">Select an organization...</option>
            {availableOrgs.map((org) => (
              <option key={org.id} value={org.id}>
                {org.name} ({org.category})
              </option>
            ))}
          </select>
          {availableOrgs.length === 0 && (
            <p className={s.hint}>
              All organizations are already bound to this group.
            </p>
          )}
        </div>

        <ButtonGroup>
          <Button
            variant="tertiary"
            onPress={handleClose}
            isDisabled={isPending}
          >
            Cancel
          </Button>
          <Button
            variant="primary"
            onPress={handleBind}
            isDisabled={!selectedOrgId || isPending}
          >
            {isPending ? "Binding..." : "Bind Organization"}
          </Button>
        </ButtonGroup>
      </div>
    </Modal>
  );
}
